import { Injectable } from "@angular/core";

import { DateService } from "./../../date.service";

@Injectable()
export class ContactDetailsService {
    status = false;
    isMLP = true;

    constructor(private dateService: DateService) {
        this.checkIsVisible();
    }

    checkIsVisible(): void {
        const date = this.dateService.now();
        const hour = date.getHours();
        const dayOfWeek = date.getDay();

        let isVisible = false;

        if (
            hour > 8 &&
            hour < 19 &&
            dayOfWeek > 0 &&
            dayOfWeek < 6 &&
            this.isMLP
        ) {
            isVisible = true;
        }

        this.status = isVisible;
    }
}
